import { useTranslation } from 'react-i18next'
import { Badge } from '../ui/badge'
import { AppIcon } from '../ui/icon'

/** A status pill read from one of the maps of campaign-status.ts. */
export function StatusPill({
    map,
    family,
    value,
    testId,
}: {
    map: Record<string, { tone: 'outline' | 'info' | 'success' | 'warning' | 'destructive' | 'secondary'; icon: string }>
    family: 'status' | 'unit_status' | 'apply_status'
    value: string
    testId?: string
}) {
    const { t } = useTranslation('campaigns')
    const entry = map[value] ?? { tone: 'outline' as const, icon: '' }
    return (
        <Badge variant={entry.tone} className="gap-1 whitespace-nowrap" data-testid={testId} data-status={value}>
            {entry.icon && <AppIcon path={entry.icon} size="xs" />}
            {t(`${family}.${value}`)}
        </Badge>
    )
}
